import axios from "axios";
import {
  ADMIN_MERCHANT_CREATE_REQUEST,
  ADMIN_MERCHANT_CREATE_SUCCESS,
  ADMIN_MERCHANT_CREATE_FAIL,
  ADMIN_MERCHANT_LIST_REQUEST,
  ADMIN_MERCHANT_LIST_SUCCESS,
  ADMIN_MERCHANT_LIST_FAIL,
  ADMIN_MERCHANT_LIST_SEARCH,
  ADMIN_MERCHANT_VIEW_REQUEST,
  ADMIN_MERCHANT_VIEW_SUCCESS,
  ADMIN_MERCHANT_VIEW_FAIL,
  MERCHANT_ADD_BRAND_REQUEST,
  MERCHANT_ADD_BRAND_SUCCESS,
  MERCHANT_ADD_BRAND_FAIL,
  MERCHANT_REMOVE_BRAND_REQUEST,
  MERCHANT_REMOVE_BRAND_SUCCESS,
  MERCHANT_REMOVE_BRAND_FAIL,
  ADMIN_MERCHANT_SEARCH_BRAND_REQUEST,
  ADMIN_MERCHANT_SEARCH_BRAND_SUCCESS,
  ADMIN_MERCHANT_SEARCH_BRAND_FAIL,
  ADMIN_MERCHANT_UPDATE_FAIL,
  ADMIN_MERCHANT_UPDATE_SUCCESS,
  ADMIN_MERCHANT_UPDATE_REQUEST,
  ADMIN_MERCHANT_UPDATE_RESET,
  MERCHANT_REMOVE,
  MERCHANT_SELECT,
} from "./merchantTypes";
import { BACK_URI } from "../../config/keys";
import { removeAlert, setAlert } from "../Alert/alert.actions";

export const selectMerchant = (name, id) => async (dispatch, getState) => {
  sessionStorage.setItem("merchantselected", JSON.stringify({ name, id }));

  dispatch({
    type: MERCHANT_SELECT,
    payload: { name, id },
  });
};
export const removeMerchantAction = () => async (dispatch, getState) => {
  sessionStorage.removeItem("merchantselected");
  dispatch({
    type: MERCHANT_REMOVE,
  });
};
export const searchFromMerchant = (value) => async (dispatch, getState) => {
  dispatch({
    type: ADMIN_MERCHANT_LIST_SEARCH,
    payload: value,
  });
};
export const createMerchant = (merchant) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADMIN_MERCHANT_CREATE_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.post(`${BACK_URI}/merchant`, merchant, config);
    dispatch({
      type: ADMIN_MERCHANT_CREATE_SUCCESS,
      payload: data,
    });
    dispatch(setAlert("Merchant Created Successfully", "success", 1500));
  } catch (error) {
    dispatch(setAlert("", "error", 2500));

    dispatch({
      type: ADMIN_MERCHANT_CREATE_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const listMerchants = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_MERCHANT_LIST_REQUEST });
    const {
      userState: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.get(`${BACK_URI}/merchant/list`, config);
    dispatch({
      type: ADMIN_MERCHANT_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_MERCHANT_LIST_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const viewMerchant = (mid) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_MERCHANT_VIEW_REQUEST });
    const {
      userState: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.get(`${BACK_URI}/merchant/${mid}`, config);
    dispatch({
      type: ADMIN_MERCHANT_VIEW_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_MERCHANT_VIEW_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const updateMerchant = (mid, body) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_MERCHANT_UPDATE_REQUEST });

    const {
      userState: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.post(`${BACK_URI}/merchant/${mid}`, body, config);
    dispatch({
      type: ADMIN_MERCHANT_UPDATE_SUCCESS,
      payload: data,
    });
    dispatch(setAlert("Merchant Updated Successfully", "success", 1500));
    dispatch({ type: ADMIN_MERCHANT_UPDATE_RESET });
    dispatch(viewMerchant(mid));
  } catch (error) {
    console.log("error", error);
    dispatch({
      type: ADMIN_MERCHANT_UPDATE_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

// brands integration
export const searchBrand = (name) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_MERCHANT_SEARCH_BRAND_REQUEST });
    const {
      userState: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.get(`${BACK_URI}/brand/searchbrand/${name}`, config);
    dispatch({
      type: ADMIN_MERCHANT_SEARCH_BRAND_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_MERCHANT_SEARCH_BRAND_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const addBrandtoMerchant = (mid, brand) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MERCHANT_ADD_BRAND_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.post(`${BACK_URI}/brand/addtomerchant/${mid}`, brand, config);
    dispatch({
      type: MERCHANT_ADD_BRAND_SUCCESS,
      payload: data,
    });
    dispatch(setAlert("Brand Added Successfully", "success", 1500));
  } catch (error) {
    dispatch(setAlert("", "error", 2500));
    dispatch({
      type: MERCHANT_ADD_BRAND_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
export const removeBrandfromMerchant = (mid, brandId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MERCHANT_REMOVE_BRAND_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.post(
      `${BACK_URI}/brand/removefrommerchant/${mid}`,
      { brandId },
      config
    );
    dispatch({
      type: MERCHANT_REMOVE_BRAND_SUCCESS,
      payload: data,
    });
    dispatch(setAlert("Brand removed Successfully", "success", 1500));
  } catch (error) {
    dispatch(setAlert("", "error", 2500));
    dispatch({
      type: MERCHANT_REMOVE_BRAND_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
